import { useState } from "react";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import { sanitizeHtml } from "@/utils/sanitizeHtml";

const FAQ = ({ title, language, data }) => {
  const [active, setActive] = useState(
    [...Array(data.length).keys()].fill(false)
  );
  return (
    <section>
      <h2 className="text-2xl font-bold max-[768px]:text-lg">{title}</h2>
      {data.map((info, i) => (
        <section key={i} className="my-5 max-[768px]:my-3">
          <div
            onClick={() =>
              setActive([
                ...active.slice(0, i),
                !active[i],
                ...active.slice(i + 1, active.length),
              ])
            }
            className={`flex items-center justify-between p-3 border rounded-md ${
              active[i] && "rounded-b-none"
            } cursor-pointer`}
          >
            <p
              className={`text-lg max-[768px]:text-sm ${
                active[i] && "font-bold"
              }`}
            >
              {info[`title-${language}`]}
            </p>
            {active[i] ? <AiOutlineMinus /> : <AiOutlinePlus />}
          </div>
          {active[i] && (
            <p
              className="p-3 border border-t-0 rounded-md rounded-t-none max-[768px]:text-sm"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(info[`description-${language}`]),
              }}
            />
          )}
        </section>
      ))}
    </section>
  );
};

export default FAQ;
